import MapDot from 'ggApp/shared/icons/MapDot/MapDot';

export default MapDot;
